<template>
  <v-card
    class="rounded-lg mb-3"
    :style="$i18n.locale === 'ar' ? 'fontFamily:serif;' : 'fontFamily:Vazir;'"
  >
    <div
      v-if="value.discount_amount && value.discount_amount>0"
      class="warning rounded-tr-0 rounded-br-lg pa-1"
      style="position: absolute; top: 0; left: 0"
      :style="$i18n.locale === 'ar' ? 'fontFamily:serif;' : 'fontFamily:Vazir;'"
    >
      <span v-if="value.discount_type !== 'price'">٪</span>
      {{ use_lang(price(value.discount_amount)) }}
      <span v-if="value.discount_type === 'price'" style="font-size: x-small">{{
        currencySymbol || 'ریال'
      }}</span>
    </div>

    <v-list-item class="px-2">
      <v-list-item-avatar
        class="rounded-lg overflow-hidden"
        color="warning"
        size="64"
      >
        <v-img :src="value.gallery | getProductImage" contain width="64" />
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title v-text="value.name" />
        <pre
          class="warning--text overflow-hidden mb-1"
          v-html="value.description"
        />
        <v-list-item-title>
          <span
            :class="
              !!value.discount_amount
                ? 'text-decoration-line-through'
                : 'primary--text'
            "
          >
            {{ use_lang(price(value.price)) }}
          </span>
          &nbsp;
          <span v-if="!!value.discount_amount" class="primary--text">
            {{ use_lang(price(priceWithDiscount)) }}
          </span>
          <span class="primary--text">{{ currencySymbol || 'ریال' }}</span>
        </v-list-item-title>
      </v-list-item-content>

      <v-list-item-action v-if="hasExtra" class="align-self-end">
        <v-dialog v-model="openMap" class="p-10" max-width="400">
          <template v-slot:activator="{ on, attr }">
            <v-btn class="me-n1" icon small v-bind="attr" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-toolbar color="primary" dark>
              <v-toolbar-title>{{ $t("features") }}</v-toolbar-title>
              <v-spacer />
              <v-toolbar-items>
                <v-btn icon @click="openMap = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <extra-shown v-model="computedExtra" class="pa-4" />
          </v-card>
        </v-dialog>
      </v-list-item-action>
    </v-list-item>
  </v-card>
</template>

<script>
import ExtraShown from "@/view/components/Product/extraShown";

export default {
  name: "mProductCard",

  components: { ExtraShown },

  props: {
    value: Object,
    currencySymbol: {
      type: String,
      default: 'ریال'
    },
    cartButtonText: {
      type: String,
      default: 'افزودن'
    }
  },

  data: () => ({
    openMap: false,
  }),
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    hasExtra() {
      let e =
        !!this.value.extra && typeof this.value.extra === "string"
          ? JSON.parse(this.value.extra)
          : [];
      return (
        e.filter(
          (item) => !!item.label || !!item.value || !!item.icon || !!item.link
        )?.length > 0
      );
    },
    computedExtra() {
      return !!this.hasExtra ? JSON.parse(this.value.extra) : [];
    },
    priceWithDiscount() {
      if (this.value.discount_type === "percent")
        return Math.floor(
          ((100 - this.value.discount_amount) * this.value.price) / 100
        );
      return this.value.price - this.value.discount_amount;
    },
  },
};
</script>

<style scoped>
pre {
  font-family: Vazir, serif !important;
  max-width: 100%;
  overflow: hidden;
  /*text-overflow: ellipsis;*/
  white-space: break-spaces;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>
